import React, { Component } from "react";
import ApiConnect from "../../../Util/ApiConnect";
import CompanyHeader from "./CompanyHeader";
import { Redirect } from "react-router-dom";
export default class TableOrder extends Component {
  constructor(props) {
    super(props);
    const paramsData = props.match.params;
    this.state = {
      company: paramsData.company,
      id: paramsData.id,
      table: paramsData.table,
      companyData: [],
      orderData: [],
      OrderList: [],
    };
  }
  componentDidMount() {
    this.fetchHandler();
  }
  fetchHandler() {
    ApiConnect.get(
      `/CustomerQR/TableOrder?company=${this.state.company}&id=${this.state.id}&table=${this.state.table}`
    )
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            companyData: response.data.company,
            orderData: response.data.order,
            OrderList: response.data.order.order,
          });
        } else {
          <Redirect to="/404" />;
        }
      })
      .catch(function (error) {
        console.log(error.toJSON());
      });
  }
  render() {
    return (
      <>
        <CompanyHeader data={this.state.companyData} />
        <div className="container position-relative">
          <div className="pt-3">
            <div className="cart-item rounded rounded shadow-sm overflow-hidden bg-white sticky_sidebar">
              <div className="d-flex border-bottom cart-item-profile bg-white p-3">
                <h6 className="mb-1 font-weight-bold">
                  Your Order Details (Bill Amount :
                  {this.state.orderData.total || 0})
                </h6>
              </div>
              <div className="bg-white border-bottom py-2">
                {this.state.OrderList &&
                  this.state.OrderList.map((order, index) => (
                    <div className="p-3 border-bottom menu-list" key={index}>
                      <div className="media">
                        <div className="media-body">
                          <div className="row">
                            <div className="col-7 menu-item">
                              <img
                                alt={order.name}
                                src={order.image}
                                className="rounded-pill "
                              />
                              <h6 className="item-name">{order.name}</h6>
                            </div>
                            <p className="col-3">
                              {order.qty}X{order.price}
                            </p>
                            <p className="col-1">{order.qty * order.price}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="bg-white p-3 clearfix border-bottom pull-right">
                <p className="mb-1">
                  Item Total
                  <span className="float-right text-dark">
                    {` ${this.state.orderData.subtotal}`}
                  </span>
                </p>
                <p className="mb-1 text-danger">
                  Restaurant Charges {this.state.orderData.service}%
                  <span className="float-right text-dark">
                    {` ${this.state.orderData.charge}`}
                  </span>
                </p>
                <p className="mb-1">
                  Delivery Fee
                  <span className="text-info ml-1">
                    <i className="feather-info" />
                  </span>
                  <span className="float-right text-dark">
                    {` ${this.state.orderData.subtotal}`}
                  </span>
                </p>{" "}
                <p className="mb-1 text-success">
                  Total Discount
                  <span className="float-right text-success">
                    {` ${this.state.orderData.discount || 0}`}
                  </span>
                </p>
                <p className="mb-1 text-danger">
                  Taxes
                  <span className="float-right text-dark">
                    {` ${this.state.orderData.tax}`}
                  </span>
                </p>
                <p className="mb-1 text-success">
                  Total Amount
                  <span className="float-right text-success">
                    {` ${this.state.orderData.total}`}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
